const buildHttpRequestOptions = (headers, functionName) => {
    return {
        headers,
        includeWixHeaders: true,
        automaticLogsOptions: {
            packageName: 'wix-data',
            functionName,
        },
    };
};
export { buildHttpRequestOptions };
//# sourceMappingURL=buildHttpRequestOptions.js.map